"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Paper = exports.DESIGN_STYLE_MAP = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const color_1 = require("../constants/color");
const theme_1 = require("../constants/theme");
const create_styles_1 = require("../utils/create-styles");
exports.DESIGN_STYLE_MAP = {
    blue: {
        backgroundColor: color_1.Color.LIGHTEST_BLUE,
        borderColor: color_1.Color.MEDIUM_LIGHT_BLUE,
    },
    white: {
        backgroundColor: color_1.Color.WHITE,
        borderColor: theme_1.theme.color.border,
    },
    red: {
        backgroundColor: color_1.Color.LIGHTEST_RED,
        borderColor: color_1.Color.RED,
    },
    green: {
        backgroundColor: color_1.Color.TRANSPARENT_GREEN,
        borderColor: color_1.Color.GREEN,
    },
};
/**
 * Inspired by the {@link https://mantine.dev/core/paper/ | Mantine documentation}:
 *
 * >Paper is the most basic ui component. Use it to create cards, dropdowns, modals and other
 * components that require background with shadow.
 */
exports.Paper = styled_1.default.div((props) => {
    const styles = exports.DESIGN_STYLE_MAP[props.design ?? 'white'];
    return {
        border: theme_1.theme.border.style.thin,
        borderRadius: theme_1.theme.border.radius.normal,
        boxShadow: theme_1.theme.boxShadow.normal,
        overflow: props.hideOverflow ? 'hidden' : undefined,
        ...styles,
        ...(0, create_styles_1.createStyles)(props.styles),
    };
});
